import React from "react";
import Modal from "../../../../../parts/modal-new";
import moment from "moment";
import { S3 } from "../../../../../constants";
import { getBodywweightAndUnit } from "../../../../../utils/converters/convert-units";
import useNearScreen from "../../../../../hooks/useNearScreen";
import { useHorizontalScroll } from "../../../../../hooks/useHorizontalScroll";
import useDragToScroll from "../../../../../hooks/useDragToScroll";
import { useRillContext } from "../../../../../rill/RillReact/share/base";

const CompareToTimelineModal = ({
  selectedPhoto,
  setSelectedPhotos,
  listToCompare,
  closeModal,
  closeModalAndReset,
}) => {
  const { locals } = useRillContext();

  const {
    activeUser: { units },
  } = locals;

  const changePicture = (photo) => {
    setSelectedPhotos((prevSelectedPhotos) => {
      return prevSelectedPhotos.filter(
        (selectedPhoto) => selectedPhoto !== photo
      );
    });
    closeModal();
  };
  const elRef = useHorizontalScroll("faster");
  const {
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    handleTouchStart,
    handleTouchMove,
    isDragging,
  } = useDragToScroll(elRef);
  return (
    <Modal
      className="compare-to-tl-ph"
      title="Compare Photos"
      onClose={closeModalAndReset}
      dontRefreshOnClose={true}
    >
      <div className="body">
        <aside>
          <article>
            <header>
              <hgroup>
                <b>
                  {moment(selectedPhoto.stat.utcDate, "YYYYMMDD").format("LL")}
                </b>

                <p>
                  {getBodywweightAndUnit(selectedPhoto.stat.bodyWeight, units)}
                </p>
              </hgroup>
              <button
                data-button-type="primary"
                onClick={() => changePicture(selectedPhoto)}
              >
                Change
              </button>
            </header>
            <img
              src={S3.toCDN(
                selectedPhoto.stat.bodyPhotos[selectedPhoto.key].s3Path
              )}
              className=""
            />
          </article>
        </aside>
        <section
          ref={elRef}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          style={{ cursor: isDragging ? "grabbing" : "grab" }}
        >
          <ul>
            {listToCompare.map((item) =>
              item._id !== selectedPhoto.stat._id ? (
                <PhotoTimeline
                  item={item}
                  units={units}
                  key={item._id}
                  bodyside={selectedPhoto.key}
                />
              ) : null
            )}
          </ul>
        </section>
      </div>
    </Modal>
  );
};
const PhotoTimeline = ({ item, units, bodyside }) => {
  const { isNearScreen, elementRef } = useNearScreen();
  const imgUri = S3.toCDN(item.bodyPhotos[bodyside]?.s3Path);

  return (
    <article ref={elementRef}>
      {isNearScreen && (
        <>
          <header>
            <span>{moment(item.utcDate, "YYYYMMDD").format("LL")}</span>

            <span>{getBodywweightAndUnit(item.bodyWeight, units)}</span>
          </header>
          <img src={imgUri} loading="lazy" />
        </>
      )}
    </article>
  );
};

export default CompareToTimelineModal;
